import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop"
import { DateObject } from "react-multi-date-picker";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";

export const useResourceRequestList = () => {

    const { showSuccess } = useContext(ToastContext);
    const [dropDownOption, setDropDownOption] = useState({});
      const [filterValues, setFilterValues] = useState({ projects: [], users: [], technology: [], status: {}, hoveredRange: [new DateObject().subtract(8, "days"), new DateObject().add(0, "days"),], isChange: false });
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const [showRequestPopup, setShowRequestPopup] = useState(false);
    const [showAssignPopup, setShowAssignPopup] = useState(false);
    const [assignData, setAssignData] = useState({});
    const [rowData, setRowData] = useState([]);
    const coldef = [
        {
            field: "assign",
            headerName: "Assign",
            width: 50,
            hide: filterValues?.status?.request_status_key === "is_approved",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="c-pointer" onClick={() => { setAssignData(params?.data); setShowAssignPopup(true); }}><FontAwesomeIcon icon="fa-solid fa-user-check" /></div>
                )
            }
        },
        {
            field: "project_name",
            headerName: "Project Name",
            width: 140,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "technology_name",
            headerName: "Technology",
            width: 150,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "resource_experience_year",
            headerName: "Resource Experience",
            width: 70,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "requested_user_name",
            headerName: "Request By",
            width: 150,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "approver_user_name",
            headerName: "Approve By",
            width: 150,
            hide: filterValues?.status?.request_status_key !== "is_approved",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "assigned_user_name",
            headerName: "Assigned To",
            width: 150,
            hide: filterValues?.status?.request_status_key !== "is_approved",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "from_date",
            headerName: "From Date",
            width: 120,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, 'day-mon-year')}</div>
                )
            }
        },
        {
            field: "to_date",
            headerName: "To Date",
            width: 120,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, 'day-mon-year')}</div>
                )
            }
        },
        {
            field: "apply_datetime",
            headerName: "Request Date",
            width: 150,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, 'date-time-months')}</div>
                )
            }
        },
    ];

    useEffect(() => {
        callautopopulate("request_status", "all_users", "projects", "user_info").then((res) => {
            const projects = res?.projects?.sort((a, b) => a?.project_name.localeCompare(b?.project_name))
            setDropDownOption({
                projects: projects,
                users: _.sortBy(res?.all_users, "user_display_name"),
                statusOptions: [res?.request_status?.[0], res?.request_status?.[1]],
                userCode: res?.user_info?.[0]?.user_code,
            })
            setFilterValues((prev) => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })
    }, [])

    useEffect(() => {
        sessionStorage.removeItem("open_opportunity_user_technology");
        sessionStorage.removeItem("technology");
        callautopopulate("open_opportunity_user_technology", "technology").then((res) => {
            setDropDownOption((prev) => ({ ...prev, openOppoUsers: res?.open_opportunity_user_technology, technologies: _.sortBy(res?.technology, "technology_name"), }))
        })
    }, [assignData])

    useEffect(() => {
        if (!_.isEmpty(assignData)) {
            const filteredOpts = _.filter(dropDownOption?.openOppoUsers, { technology_name: assignData?.technology_name });
            setDropDownOption((prev) => ({ ...prev, filteredUsers: _.sortBy(filteredOpts, "user_display_name") }));
        }
    }, [assignData, dropDownOption?.openOppoUsers])

    useEffect(() => {
        if (filterValues?.status?.request_status_id && filterValues?.apiCall) {
            getResourceRequestList();
        }
    }, [filterValues?.status, filterValues?.apiCall]);

    const getResourceRequestList = async (key) => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            const payload = {
                project_ids: key === "projects" ? "" : _.pluck(filterValues?.projects, "project_id")?.toString(),
                request_status_id: filterValues?.status?.request_status_id,
                from_date: (filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : "",
                to_date: (filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : "",
                users: key === "users" ? "" : _.pluck(filterValues?.all_users, "user_code")?.toString(),
                technology_name: key === "technology" ? "" : _.pluck(filterValues?.technology, "technology_name")?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETRESOURCEREQUESTLIST"), payload);
            if (res) {
                let data = res?.body?.data?.resource_request_list;
                data = data.sort((a, b) => { return new Date(b?.apply_datetime) - new Date(a?.apply_datetime) });
                setRowData(data);
                setLoader((prev) => ({ ...prev, grid: false }));
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            console.error("Error: ", error);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value),
        });
        setFilterValues((prev) => ({ ...prev, status: data ,apiCall:true}));
    };

    const handleAssign = async () => {
        try {
            setLoader((prev) => ({ ...prev, btn: true }));
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })
            const payload = {
                resource_request_id: assignData?.resource_request_id,
                request_status_id: requestStatus?.request_status_id,
                assigned_user_code: assignData?.selected_user?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTRESOURCEREQUESTAPPROVE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setAssignData({});
                setShowAssignPopup(false);
                getResourceRequestList();
                setLoader((prev) => ({ ...prev, btn: false }));
            } else {
                setLoader((prev) => ({ ...prev, btn: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    return useMemo(() => ({
        dropDownOption, handleStatusChange, filterValues, setFilterValues, getResourceRequestList, loader, rowData, coldef, showRequestPopup, setShowRequestPopup, showAssignPopup, setShowAssignPopup, handleAssign, assignData, setAssignData
    }), [dropDownOption, handleStatusChange, filterValues, setFilterValues, getResourceRequestList, loader, rowData, coldef, showRequestPopup, setShowRequestPopup, showAssignPopup, setShowAssignPopup, handleAssign, assignData, setAssignData])
}